import React from 'react';

interface TrendingUpIconProps {
  width?: number | string;
  height?: number | string;
  fill?: string;
  className?: string;
}

const TrendingUpIcon: React.FC<TrendingUpIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  className,
}) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6h-6z" fill={fill} />
  </svg>
);

export default TrendingUpIcon;
